var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('calendesk-ai-assistant',{attrs:{"api-url":_vm.apiUrl,"token-source":"localStorage","token-key":"accessToken","theme":"light"},on:{"click":_vm.onWidgetClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }